import axios from "axios"

export const getComercioById = async (idComercio: string) => {
    return axios.get(`api/Comercio/ObtenerComercio?idComercio=${idComercio}`)
        .catch((val) => val);
}
